import React, { useState, useRef, useLayoutEffect } from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var getUniqueFormatDelimiters = function getUniqueFormatDelimiters(formats, formatChar) {
  return _toConsumableArray(new Set(formats.join("").split(formatChar).join("").split("")));
};
var format = function format(formatter) {
  return function (value) {
    var usedFormat = formatter.formats[value.length];

    if (!usedFormat) {
      return value;
    }

    var formatPieces = usedFormat.split(formatter.formatChar);
    var valuePieces = value.split("");
    var zipped = formatPieces.map(function (v, i) {
      return v + (valuePieces[i] || "");
    });
    return zipped.join("");
  };
};

var countDelims = function countDelims(formatter, index) {
  var count = 0;
  var format = formatter.formats[index];
  if (!format) return 0;
  formatter.uniqueDelimiters.forEach(function (delim) {
    return count += format.split(delim).length - 1;
  });
  return count;
};

var unformat = function unformat(formatter) {
  return function (formattedValue, formatIndex) {
    if (formatIndex >= formatter.formats.length) {
      return formattedValue;
    }

    var format = formatter.formats[formatIndex];
    return formattedValue.split("").filter(function (_, i) {
      return !(format[i] != formatter.formatChar);
    }).join("");
  };
};
var inject = function inject(baseString) {
  return function (start, end, newString) {
    return baseString.substring(0, start) + newString + baseString.substring(end);
  };
};
var formattedToUnformattedIndex = function formattedToUnformattedIndex(formattedIndex, rawValue, formatter) {
  var maxFormatExceeded = rawValue.length >= formatter.formats.length;

  if (maxFormatExceeded) {
    return formattedIndex;
  } else {
    var formatString = formatter.formats[rawValue.length];
    var beforeString = formatString.slice(0, formattedIndex);
    return beforeString.split("").filter(function (c) {
      return c === formatter.formatChar;
    }).length;
  }
};
var unformattedToFormattedIndex = function unformattedToFormattedIndex(rawIndex, rawValue, formatter, del) {
  var maxFormatExceeded = rawValue.length >= formatter.formats.length; // If forced to stay formatted, offset by delims - 1
  // This is done so the component doesn't assume that any added chars will be kept
  // (i.e. if an external constraint is applied)

  if (maxFormatExceeded) {
    var delims = countDelims(formatter, rawValue.length - 1);
    return delims > 0 && !del ? rawIndex + delims - 1 : rawIndex;
  } else {
    return formatter.formats[rawValue.length].split(formatter.formatChar).slice(0, rawIndex).reduce(function (acc, curr) {
      return curr.length + acc;
    }, 0) + rawIndex;
  }
};

var createFormat = function createFormat(formats, formatChar) {
  return {
    uniqueDelimiters: getUniqueFormatDelimiters(formats, formatChar),
    formats: formats,
    formatChar: formatChar
  };
};

var FormattedInput = function FormattedInput(_ref) {
  var value = _ref.value,
      formatter = _ref.formatter,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ["value", "formatter", "onChange"]);

  var _useState = useState(format(formatter)(value)),
      _useState2 = _slicedToArray(_useState, 2),
      formattedValue = _useState2[0],
      setFormattedValue = _useState2[1];

  var inputEl = useRef(null);
  var stateRefs = useRef({
    selectionStart: 0,
    selectionEnd: 0,
    isDelete: false,
    rawValue: ''
  });
  useLayoutEffect(function () {
    // A lot of the work here is cursor manipulation
    if (inputEl.current && inputEl.current === document.activeElement) {
      inputEl.current.setSelectionRange(stateRefs.current.selectionStart, stateRefs.current.selectionEnd);
    }
  }, [stateRefs]);

  var handleChange = function handleChange(event) {
    var deleteKeyPressed = stateRefs.current.isDelete;
    var maxFormatExceeded = stateRefs.current.rawValue.length >= formatter.formats.length - 1;

    if (maxFormatExceeded && !deleteKeyPressed) {
      return;
    }
    /* At the beginning of onChange, event.target.value is a concat of the previous formatted value
    * and an unformatted injection at the start, end, or in the middle (maybe a deletion). To prepare 
    * the unformatted value for the user's onChange, the formatted string and unformatted injection need
    * to be separated, then unformat the formatted string, then insert (or delete) the injection from the
    * old unformatted value.
    */


    var injectionLength = event.target.value.length - formattedValue.length;
    var end = stateRefs.current.selectionStart === stateRefs.current.selectionEnd ? stateRefs.current.selectionStart + injectionLength : stateRefs.current.selectionEnd - 1;
    var injection = event.target.value.substring(stateRefs.current.selectionStart, end); // Injection is the new unformatted piece of the input
    // Need to find where to put it

    var rawInjectionPointStart = formattedToUnformattedIndex(stateRefs.current.selectionStart, stateRefs.current.rawValue, formatter);
    var rawInjectionPointEnd = formattedToUnformattedIndex(stateRefs.current.selectionEnd, stateRefs.current.rawValue, formatter); // Unformat the previous formatted value for injection
    // Using the relevant format string, strips away chars not marked with the formatChar

    var unformattedOldValue = unformat(formatter)(formattedValue, stateRefs.current.rawValue.length); // Edit the previous unformatted value (either add, update or delete)

    var injectIntoOldValue = inject(unformattedOldValue);
    var unformattedNewValue = deleteKeyPressed ? rawInjectionPointStart === rawInjectionPointEnd ? injectIntoOldValue(rawInjectionPointStart - 1, rawInjectionPointStart, "") : injectIntoOldValue(rawInjectionPointStart, rawInjectionPointEnd, "") : injectIntoOldValue(rawInjectionPointStart, rawInjectionPointEnd, injection);
    var lengthDifference = unformattedNewValue.length - stateRefs.current.rawValue.length;
    var rawIndex = formattedToUnformattedIndex(stateRefs.current.selectionStart, stateRefs.current.rawValue, formatter) + lengthDifference; // Find the new cursor position for the potential formatted value
    // Applied by useLayoutEffect

    var newFormattedCursorPosition = stateRefs.current.selectionStart === stateRefs.current.selectionEnd ? unformattedToFormattedIndex(rawIndex, unformattedNewValue, formatter, deleteKeyPressed) : deleteKeyPressed ? stateRefs.current.selectionStart : stateRefs.current.selectionEnd;
    var formattedNewValue = format(formatter)(unformattedNewValue);
    setFormattedValue(formattedNewValue); // Apply the external onChange function to the raw underlying string
    // This is where the user generally updates the input value

    if (onChange) {
      onChange(unformattedNewValue);
    }
  };

  return React.createElement("input", _extends({}, props, {
    ref: inputEl,
    value: format(formatter)(value),
    onKeyDown: function onKeyDown(event) {
      // Keep track of the state of the input before onChange
      stateRefs.current = {
        isDelete: event.key === "Backspace" || event.key === "Delete",
        selectionStart: event.target.selectionStart,
        selectionEnd: event.target.selectionEnd,
        rawValue: value
      };
    },
    onChange: handleChange
  }));
};

export { FormattedInput, createFormat, format };
